(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Tabs
  const tabs = document.querySelectorAll('.tabs-nav li');
  const panes = document.querySelectorAll('.tab-pane');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const target = tab.dataset.tab;
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      panes.forEach(p => {
        p.classList.remove('active');
        if (p.id === target) p.classList.add('active');
      });
    });
  });

  // ✅ Quantity Button Logic
  const qtyInput = document.querySelector('.quantity-selector input');
  const plusBtn = document.querySelector('.quantity-selector .plus');
  const minusBtn = document.querySelector('.quantity-selector .minus');

  if (plusBtn && minusBtn && qtyInput) {
    plusBtn.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value || 1) + 1;
    });
    minusBtn.addEventListener('click', () => {
      if (parseInt(qtyInput.value || 1) > 1) {
        qtyInput.value = parseInt(qtyInput.value) - 1;
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
